import React, { useEffect, useState, Fragment } from "react";
import Button from "../../_components/button/Button";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/outline";
import { XCircleIcon } from "@heroicons/react/solid";
import { Dialog, Transition } from "@headlessui/react";

const technologies = [
  {
    id: 1,
    title: "Dolby Atmos",
    description:
      "Dolby Atmos is an object-based surround format that allows content creators to place each sound exactly where they want it to go, creating a more realistic and immersive audio experience. No matter what you're listening to, Dolby Atmos adapts automatically to your device and system, so you'll get the highest quality experience.",
  },
  {
    id: 2,
    title: "DTS:X",
    description:
      "DTS:X is the next-generation audio codec from DTS that leverages object-based audio to enable new audio experiences in immersion and interactivity.",
  },
  {
    id: 3,
    title: "DTS Virtual:X",
    description:
      "DTS Virtual:X is an audio codec designed to provide sound with a sense of multi-dimensional space or of sound moving around you within an environment. Used in both cinemas and home theater systems, DTS Virtual:X may sound complicated, but it can be understood as making a few speakers sound like many speakers.",
  },
  {
    id: 4,
    title: "IMAX Enhanced",
    description:
      "IMAX ENHANCED is the only way to experience IMAX's signature picture, sound and scale in the home. IMAX Enhanced combines digitally remastered 4K HDR content and DTS audio technologies with best-in-class consumer electronics products and streaming platforms.",
  },
  {
    id: 5,
    title: "Dolby Vision",
    description:
      "Dolby Vision is a dynamic HDR format, similar to HDR 10+, supporting the highest peak brightness and bit depth available today. Optimized for every scene, this advanced HDR technology gives you excellent colour and contrast, in consistent quality..",
  },
  {
    id: 6,
    title: "HDR 10",
    description:
      "HDR stands for high dynamic range. The aim is to recreate an image closer to that seen by the human eye or better recreate the original storyteller's vision. That often means balancing out light and dark areas or the range of colours, and not losing, for example, shadow detail because of a bright sky.",
  },
  {
    id: 32,
    title: "HDR 10+",
    description:
      "Similar to HDR 10, HDR 10+ takes the benefits of HDR 10 and improves upon them. For example, it quadruples the maximum brightness to 4,000 nits, which thereby increases contrast. It also changes the way it handles information. With HDR 10, metadata that is fed by the content source is static, which means there is one set of values established for a whole piece of content, such as a movie. HDR 10+ makes this metadata dynamic, allowing it to change for each video frame. This means every frame is treated with its own set of colours, brightness, and contrast parameters, making for a more realistic-looking image.",
  },
  {
    id: 7,
    title: "HDMI 2.1",
    description:
      "HDMI 2.1 allows for higher resolutions, higher frame rates and significantly more bandwidth (up to 48gbps). It allows you to take your home entertainment to the next level with features such as HDR10, HDR10+, ALLM, VRR, QMS, QFT support and much more.",
  },
  {
    id: 8,
    title: "HDCP 2.3",
    description:
      "HDCP 2.3 or High-bandwidth Digital Content Protection is the encryption technology that was designed to prevent illegal copying of 4K Ultra HD content as it's transmitted via HDMI. HDCP 2.3 is the latest version. It provides the most secure digital handshake between a source, sync and repeater.",
  },
  {
    id: 9,
    title: "eARC",
    description:
      "eARC or Enhanced Audio Return Channel allows digital audio data to be transferred solely via the HDMI cable. In that sense, the HDMI cable sends both visual and audio information back and forth between your TV and a Sound Bar or, in this case, the AVM 90.",
  },
  {
    id: 10,
    title: "HLG",
    description:
      "HLG or Hybrid Log-Gamma is yet another HDR format developed with the BBC (British Broadcasting Corporation) and NHK, Japan's national broadcaster. HLG codes HDR and SDR information into a single signal, enabling HDR-compatible TVs to display an enhanced image.",
  },
  {
    id: 11,
    title: "VRR",
    description:
      "VRR stands for Variable Refresh Rate, and it allows a TV to sync its refresh rate in real-time to the frame rate output by today's popular gaming consoles resulting in a smooth, 'tear' free experience.",
  },
  {
    id: 12,
    title: "ALLM",
    description:
      "ALLM stands for Auto Low Latency Mode. When available, it automatically sets the display device to the lowest possible latency settings to improve the response time when playing even the most competitive games.",
  },

  {
    id: 15,
    title: "Four Sub Out",
    description:
      "Four Independent sub outputs allow ARC Genesis to correct multiple subs individually for frequency response, time, and phase alignment.",
  },
  {
    id: 16,
    title: "Upgraded Audio Circuitry",
    description:
      "AVM 90 uses the highest quality parts in the audio signal path in order to preserve even the most minute of details.",
  },
  {
    id: 17,
    title: "0.01% Resistors",
    description:
      "For the most pristine signal delivery possible, extremely high tolerance resistors are used in the design.",
  },
  {
    id: 18,
    title: "6-Layer PCB",
    description:
      "Premium high-layer count circuit boards with additional isolating ground planes provide design flexibility and deliver ultra-high-speed transfer rates.",
  },
  {
    id: 19,
    title: "32-Bit/768kHz DAC",
    description:
      "It is not possible to listen to a purely digital signal, at some point, it must be converted to analog to be played back. Preserving all the information in the signal is of utmost importance, so these top-tier Digital to Analog Convertors (DACs) are used to ensure that nothing is lost during the inevitable transition from today's high bandwidth digital signals, to the sound you hear from your speakers. ",
  },
  {
    id: 20,
    title: "Wi-Fi/Ethernet",
    description:
      "Both Wired and Wireless connections are available so that AVM 90 can connect to your home network for software updates, IP control, and music streaming purposes.",
  },
  {
    id: 21,
    title: "IP and Serial Control",
    description:
      "AVM 90 Features RS232 Serial and IP control capabilities for easy customization and compatibility with third-party integration solutions.",
  },
  {
    id: 22,
    title: "Apple AirPlay",
    description:
      "AVM 90 supports Apple AirPlay and AirPlay 2, letting the user stream audio content, plus songs stored on local networks, to any AirPlay-enabled device. In addition, AirPlay 2 adds support for multi device play so you can hear your music throughout the home.",
  },
  {
    id: 23,
    title: "Google Chromecast Audio",
    description:
      "Google Chromecast, lets the user stream audio content from any Android device like a phone, tablet, or laptop to the AVM 90. If you can listen to it on your phone, it can be Cast to your processor.",
  },
  {
    id: 24,
    title: "Spotify Connect",
    description:
      "Spotify Connect allows you to turn your smartphone into a remote and allows you to play, pause, and stream content from Spotify directly to your AVM 90.",
  },
  {
    id: 25,
    title: "Bluetooth",
    description:
      "All AVM/MRX components support Bluetooth to stream songs stored on devices like phones, tablets, and laptops for maximum convenience.",
  },
  {
    id: 26,
    title: "Roon Ready (Coming Soon!)",
    description:
      "Roon allows you to connect, stream and manage your music collection. Roon tells your music what to do and where to do it. Roon Ready means you can take full advantage of Roon's lossless audio capabilities.",
  },
  {
    id: 27,
    title: "Dual HDMI Outputs",
    description:
      "Two 'mirrored' HDMI outputs allow AVM 90 to share the same video source to two different displays simultaneously.",
  },
  {
    id: 28,
    title: "Zone 2 HDMI Output",
    description:
      "The Zone 2 HDMI output is a user-selectable video output that allows the same or a different source from the main zone to be output to another display.",
  },
  {
    id: 29,
    title: "Anthem Room Correction",
    description:
      "Anthem Room Correction is an award-winning software package that takes real-world, in-room acoustic measurements and uses them to fine-tune and optimize your speakers and subwoofers so they sound the best they can in your unique environment.",
  },
  {
    id: 30,
    title: "TFT Display",
    description:
      "AVM 90's adjustable brightness crystal clear front display easily shows you vital information at a glance.",
  },
  {
    id: 31,
    title: "Web UI",
    description:
      "All MRX/AVM products have moved away from yore's 'clunky' on-screen interfaces to a modern, dynamic interface easily accessed on any computer, tablet or mobile device. This allows for easy setup, configuration and adjustment of all settings without interrupting the content on the screen. Truly a 'tweakers paradise!' ",
  },
];

const Technologies = () => {
  const [open, setOpen] = useState(true);
  const [page, setPage] = React.useState(1);
  const [items, setItems] = React.useState([]);
  const [highlighted, setHighlighted] = React.useState({});

  const page_size = 12;

  const handleNext = () => {
    setPage(
      page == technologies.length / page_size ||
        page > technologies.length / page_size
        ? 1
        : page + 1
    );
  };
  const handlePrev = () => {
    setPage(page == 1 ? 1 : page - 1);
  };

  useEffect(() => {
    setItems(technologies.slice((page - 1) * page_size, page * page_size));
  }, [page]);

  return (
    <>
      {highlighted.title && (
        <Transition.Root show={open} as={Fragment}>
          <Dialog
            as="div"
            className="fixed z-50 inset-0 overflow-y-auto"
            onClose={setOpen}
          >
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <div className="inline-block align-bottom bg-white rounded-lg  text-left overflow-hidden shadow-xl transform transition-all  sm:align-middle sm:max-w-sm sm:w-full ">
                  <div>
                    <div className="text-center">
                      <Dialog.Title
                        as="h3"
                        className="relative text-lg leading-6 font-medium text-gray-900"
                      >
                        <XCircleIcon
                          className="absolute top-1 right-1 text-white h-8 cursor-pointer"
                          onClick={() => setOpen(false)}
                        />

                        <h3 className="rounded-t-md p-6 py-8 text-center text-xl bg-red-900 text-white">
                          {highlighted.title || items[0].title}
                        </h3>
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-md  font-light  p-6 py-8 h-full">
                          {highlighted.description || items[0].description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>
      )}
      <section
        className="z-50 relative bg-gradient-to-t from-gray-900 to-gray-500"
        id="technologies"
      >
        <div className="py-16 px-6 md:py-20">
          <div className="max-w-7xl mx-auto z-50">
            <h4 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center text-gray-50 leading-snug ">
              Integrating all of today's technologies into a single component.
            </h4>

            <div className="mt-20 relative">
              <div className=" grid  grid-cols-2 md:grid-cols-3 lg:grid-cols-4   sm:m-auto  gap-2">
                {items?.map((technology) => (
                  <div
                    key={technology.id}
                    onClick={() => {
                      setHighlighted(technology);
                      setOpen(true);
                    }}
                    className=" drop-shadow-sm  group cursor-pointer text-gray-500 font-medium rounded-md bg-gray-100  py-12 hover:bg-gray-500 hover:text-white"
                  >
                    <h3 className="text-center lg:text-lg text-xl  font-normal   ">
                      {technology.title}
                    </h3>
                  </div>
                ))}
              </div>
            </div>
            <div className="w-3/4 text-center mt-10 m-auto">
              <div className="grid    grid-cols-2 gap-4 justify-items-stretch">
                <div className="justify-self-end ">
                  <Button
                    // name={`Show ${count == 16 ? "more" : "less"}`}
                    name={<ChevronLeftIcon className="h-6 w-6" />}
                    dark={true}
                    centered={true}
                    width={"fit"}
                    handleClick={handlePrev}
                    disabled={page == 1 ? true : false}
                  />
                </div>
                <div className="justify-self-start ">
                  <Button
                    // name={`Show ${count == 16 ? "more" : "less"}`}
                    name={<ChevronRightIcon className="h-6 w-6" />}
                    dark={true}
                    centered={true}
                    width={"fit"}
                    handleClick={handleNext}
                    disabled={
                      page >= Math.ceil(technologies.length / page_size)
                        ? true
                        : false
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Technologies;
